module.exports = __webpack_public_path__ + "img/recepcionista.219f6085.png";